import styles from './InfoBar.module.scss';
import {
  trackInteraction,
  useSessionStorage,
  useHash,
} from '@components/hooks';
import { usePageData } from '@components/context';
import React, { useEffect, useMemo } from 'react';
import { Banner } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const isPageIncluded = ({ pageList }) =>
  pageList &&
  pageList?.some(({ pageName }) => pageName === window.location.pathname);

const randomBanner = array => array[Math.floor(Math.random() * array.length)];

const isNameInStorage = (name, storage) => storage?.includes(name);

// get one infobar for the current page
const useInfobar = (list, storage) => {
  const [hash] = useHash();
  const validBanners = useMemo(() => {
    return list.reduce((finalList, banner) => {
      if (
        (banner.exception === 'whiteList' && isPageIncluded(banner)) ||
        (banner.exception === 'blackList' && !isPageIncluded(banner))
      ) {
        if (banner?.piwikId && hash?.substring(1) !== banner.piwikId) {
          return finalList;
        }
        return [...finalList, banner];
      }
      return finalList;
    }, []);
  }, [list, window.location.pathname, hash]);

  // Check if there is a high priority banner
  const highPriorityBanner = useMemo(
    () =>
      validBanners.reduce((result, banner) => {
        if (
          banner.exception === 'whiteList' &&
          !isNameInStorage(banner.name, storage)
        ) {
          return [...result, banner];
        }
        return result;
      }, []),
    [validBanners, storage],
  );

  // filter out the high prio banners
  const generalBanners = validBanners
    .filter(item => !highPriorityBanner.includes(item))
    .reduce((result, banner) => {
      if (!isNameInStorage(banner.name, storage)) {
        return [...result, banner];
      }
      return result;
    }, []);

  // Show one Banner for each page
  return highPriorityBanner?.length > 0
    ? { ...highPriorityBanner[0], hash }
    : { ...randomBanner(generalBanners), hash };
};

const InfoBar = ({ show, setShow }) => {
  const { infobar } = usePageData();
  const list = infobar?.list ?? [];

  const [storage, setStorage] = useSessionStorage('show-infobar', []);

  const bannerToShow = useInfobar(list, storage);
  const { color, details, fontAwesomeIcon, hash, name, piwikId } =
    bannerToShow || {};

  useEffect(() => {
    if (name && !isNameInStorage(name, storage)) {
      setShow(true);
    }
  }, [hash]);

  if (!name) {
    return null;
  }

  const handleClose = () => {
    setShow(false);
    setStorage([...storage, name]);
    trackInteraction(`${name};Schließen;general;false`);
  };

  return (
    show && (
      <div className={classNames(styles.infobar, { infoBarCdp: piwikId })}>
        <Banner
          color={color}
          details={details}
          handleClose={handleClose}
          icon={fontAwesomeIcon}
        />
      </div>
    )
  );
};
export default InfoBar;
